export const ParagraphBold = ({ children }) => {
    return <p className="text-base leading-normal font-medium text-gray-600 ">{children}</p>
}
  
export default ParagraphBold
  